import React, { useState, useEffect } from 'react';
import './Hero.css';
import RequestQuoteModal from './RequestQuoteModal';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const slides = [
    {
      title: "Empowering Businesses",
      subtitle: "Tech Excellence",
      description: "Lorem ipsum dolor sit amet consectetur. Condimentum lectus posuere augue et lorem mollis elementum dignissim ornare. Malesuada facilisi pretium vitae odio. Urna ultricies quis elit mi vitae."
    },
    {
      title: "Innovative Solutions",
      subtitle: "Digital Transformation",
      description: "Transform your business with cutting-edge technology solutions. We help companies navigate the digital landscape and achieve sustainable growth through innovation."
    },
    {
      title: "Expert Development",
      subtitle: "Quality Delivery",
      description: "Our team of experienced developers creates robust, scalable applications tailored to your business needs. From concept to deployment, we ensure excellence at every step."
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-slide">
          <div className="hero-content">
            <h1 className="hero-title">
              {slides[currentSlide].title}<br />
              through <span className="hero-highlight">{slides[currentSlide].subtitle}</span>
            </h1>
            <p className="hero-description">
              {slides[currentSlide].description}
            </p>
            <button className="hero-cta" onClick={() => setIsModalOpen(true)}>Get Started</button>
          </div>
          <div className="hero-image">
          <div className="floating-tag tag-php">PHP</div>
          <div className="floating-tag tag-css">CSS</div>
          <div className="floating-tag tag-html">HTML</div>
          <div className="code-window">
            <div className="code-header">
              <span className="code-dot"></span>
              <span className="code-dot"></span>
              <span className="code-dot"></span>
            </div>
            <div className="code-content">
              <div className="code-line">&lt;style&gt;</div>
              <div className="code-line">  &lt;!HTML-loream dolor sit!HTML--&gt;</div>
              <div className="code-line">  &lt;/style&gt;</div>
              <div className="code-line">&lt;style&gt;</div>
              <div className="code-line">  web layout design</div>
            </div>
          </div>
          <div className="developer-illustration">
            <div className="developer-screen"></div>
            <div className="developer-person"></div>
            <div className="developer-desk"></div>
            <div className="plant-decoration"></div>
            <div className="gear-decoration gear-1"></div>
            <div className="gear-decoration gear-2"></div>
          </div>
          </div>
        </div>
        
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
      
      <RequestQuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default Hero;
